import _typedArrayConstructor from "../internals/typed-array-constructor";
var createTypedArrayConstructor = _typedArrayConstructor;

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor("Uint8", function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});
export default {};